import { render } from "./calculator_output_currency.vue?vue&type=template&id=40bd1028"
import script from "./calculator_output_currency.vue?vue&type=script&lang=js"
export * from "./calculator_output_currency.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/wp-content/themes/w2w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__